import {
	ADMINGETFEEMASTERLIST_SUCCESS,
	ADMINGETFEEMASTERLIST_FAILED,
	RESET_ADMINGETFEEMASTERLIST,
	LOADING_ADMINGETFEEMASTERLIST,
	NETWORK_ERROR_ADMINGETFEEMASTERLIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETFEEMASTERLIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETFEEMASTERLIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETFEEMASTERLIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETFEEMASTERLIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETFEEMASTERLIST:
			return (state = initialState);
		default:
			return state;
	}
};
